import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { captainBillingKeys } from "./query-keys";
import { captainBillingUrl } from "./url";
import type { CaptainBillingAccount } from "../types";

import { instance } from "@/lib/axios/instance";

export function useCaptainBillingAccount(clientId: string | undefined, enabled = true) {
  return useQuery<CaptainBillingAccount, AxiosError>({
    queryKey: captainBillingKeys.account(clientId ?? ""),
    queryFn: () =>
      instance.get<CaptainBillingAccount>(captainBillingUrl(clientId!, "Account")).then((res) => res.data),
    enabled: enabled && !!clientId,
    refetchOnMount: true,
  });
}
